import React from "react";

export default function SpinnerButtonMedium() {

  return (

    <div className="spinner-border spinner-border-sm text-light" role="status">
      <span className="sr-only"></span>
    </div>

  );
}
